module.exports = __webpack_public_path__ + "img/yanglaomoshi_bg.bfd0941f.png";